<template>
  <Modal
    :show="show"
    width="medium"
    hide-default-actions
    @close="close"
  >
    <template #title>
      Create New Profile Template
    </template>

    <template #content>
      <CreateProfileTemplateForm
        ref="templateForm"
        @created="onCreated"
      />
    </template>
  </Modal>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import CreateProfileTemplateForm from '@/components/shared/CreateProfileTemplateForm.vue';
import Modal from '@/components/shared/Modal.vue';

defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(['close']);

const router = useRouter();
const templateForm = ref(null);

const close = () => {
  templateForm.value?.resetForm();

  emit('close');
};

const onCreated = ({ template_ulid: templateUlid }) => {
  router.replace({
    name: 'job-profile-view',
    params: { id: templateUlid },
  });
  close();
};
</script>
